/* eslint-disable no-useless-escape */

import { store } from '../../configureStore';

export const allowOnlyNumbers = (value) => {
  if (!value) {
    return value;
  }
  // Reject other than numbers
  return value.replace(/[^\d]/g, '');
};

export const normalizePhoneNumberRedesign = (value, previousValue = true) => {
  if (!value) {
    return value;
  }
  const onlyNums = value.replace(/[^\d]/g, '');
  if (!previousValue || value.length > previousValue.length) {
    if (onlyNums.length === 3) {
      return `${onlyNums}.`;
    }
    if (onlyNums.length === 6) {
      return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3, 6)}-`;
    }
    if (onlyNums.length === 10) {
      return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3, 6)}-${onlyNums.slice(6, 10)}`;
    }
  }
  if (onlyNums.length <= 3) {
    return onlyNums;
  }
  if (onlyNums.length <= 6) {
    return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3, 6)}`;
  }
  return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3, 6)}-${onlyNums.slice(6, 10)}`;
};

export const normalizePhoneNumber = (value, previousValue = true) => {
  if (!value) {
    return value;
  }
  const onlyNums = value.replace(/[^\d]/g, '');
  if (!previousValue || value.length > previousValue.length) {
    if (onlyNums.length === 3) {
      return `${onlyNums}.`;
    }
    if (onlyNums.length === 6) {
      return `${onlyNums.slice(0, 3)}.${onlyNums.slice(3, 6)}.`;
    }
    if (onlyNums.length === 10) {
      return `${onlyNums.slice(0, 3)}.${onlyNums.slice(3, 6)}.${onlyNums.slice(6, 10)}`;
    }
  }
  if (onlyNums.length <= 3) {
    return onlyNums;
  }
  if (onlyNums.length <= 6) {
    return `${onlyNums.slice(0, 3)}.${onlyNums.slice(3, 6)}`;
  }
  return `${onlyNums.slice(0, 3)}.${onlyNums.slice(3, 6)}.${onlyNums.slice(6, 10)}`;
};

export const isValidZipCode = (ZipCode) => /^\d{5}-\d{4}$|^\d{5}$/.test(ZipCode) && !/^[0]{5}$/.test(ZipCode) && !/^[9]{5}$/.test(ZipCode);

export const isValidNANPPhoneNumber = (phone) => /^\(?([2-9]{1})\)?([0-9]{2})\)?[.]?([2-9]{1})\)?([0-9]{2})[.]?([0-9]{4})$/.test(phone);

export const isValidEmail = (value) => /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i.test(value);

export const isNameWithSpaces = (name) => /^[a-zA-Z+\s]+$/.test(name);

export const isValidPhoneNumber = (phone) =>
  /^(\+?1-?)?(\([2-9]([02-9]\d|1[02-9])\)|[2-9]([02-9]\d|1[02-9]))-?[2-9]([02-9]\d|1[02-9])-?\d{4}$/i.test(phone);

export const isValidAddress = (AddressOne) => /^[a-zA-Z0-9\-\. ',#&;/\s]+$/i.test(AddressOne);

export const isValidAddressLine2 = (address) => /^[\w .,]+$/.test(address);

export const isValidSSN = (ssn) => /^\d{9}$/.test(ssn);

export const isValidNumber = (number) => new RegExp('^[0-9]+$').test(number);

export const isNotSamePhoneNumber = (phone) => /^(1{10}|2{10}|3{10}|4{10}|5{10}|6{10}|7{10}|8{10}|9{10}|0{10}|(1234567890))$/i.test(phone);
export const isPhoneNumberNotRepeatedDigits = (phone) =>
  /^(0123456789|1234567890|2345678901|6789012345|7890123456|8901234567|9012345678)$/i.test(phone);

export const isValidDOB = (dateOfBirth, state) => {
  store.dispatch({ type: 'BELOW_AGE_ERROR', response: false });
  const yr = new Date(dateOfBirth).getFullYear();
  if (yr < 1900 || yr > 2099) {
    return false;
  }
  const today = new Date();
  const birthDate = new Date(dateOfBirth);
  let age = today.getFullYear() - birthDate.getFullYear();
  const year = birthDate.getFullYear();
  const differntMonth = today.getMonth() - birthDate.getMonth();
  let ageRestriction = 18;
  if (state !== undefined && state === 'AL') {
    ageRestriction = 19;
  }
  if (differntMonth < 0 || (differntMonth === 0 && today.getDate() <= birthDate.getDate())) {
    age -= 1;
  }
  if (dateOfBirth.indexOf('0000') > -1) {
    return false;
  }
  if (year && (year < 1900 || year > 2099)) {
    return false;
  }
  if (!Number.isNaN(age) && age < ageRestriction) {
    store.dispatch({ type: 'BELOW_AGE_ERROR', response: true });
    return false;
  }
  if (Number.isNaN(age)) {
    return false;
  }
    return /^(0?[1-9]|1[012])\/(0?[1-9]|[12][0-9]|3[01])\/\d{4}$/i.test(dateOfBirth);
};

export const isValidLabelsDate = (selectedFCCDate) => {
  const today = new Date();
  const formatedFCCDate = new Date(selectedFCCDate);
  const year = formatedFCCDate.getFullYear();
  const month = 1+formatedFCCDate.getMonth();
  const date = formatedFCCDate.getDate();
  // validation for entered date should be <= today date
  if(date && month && year){
    if((date > today.getDate() && month >= today.getMonth()+1 && year >= today.getFullYear()) 
      || (month > today.getMonth()+1 && year >= today.getFullYear()) 
      || year > today.getFullYear())
    {
      return false
    }
    
    // past till date 03/20/2024
    if(year < 2024 || ((month < 3 ) || (date < 20 && month <=3 ) && year <=2024)){
      return false
    }
  }
  return /^(0?[1-9]|1[012])\/(0?[1-9]|[12][0-9]|3[01])\/\d{4}$/i.test(selectedFCCDate);
};

export const isBetween = (n, a, b) => {
  if (!n) {
    return n;
  }
  return (n - a) * (n - b) <= 0;
};
export const isValidCity = (name) => /^[a-zA-Z\s]+$/.test(name);
export const isValidName = (name) => /^[a-zA-Z]+$/.test(name);
export const isValidNameWithSpace = (name) => /^([a-zA-Z]+\s)*[a-zA-Z]+$/.test(name);

export const isValidNameWithHyphen = (name) => /^[a-zA-Z-]+$/.test(name);

export const isValidCreditCardNumber = (value) => {
  if (!/^[*]{12}/gm.test(value)) {
    return (
      /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|3[47][0-9]{13}|6(?:011|5[0-9]{2})[0-9]{12})$/i.test(value) || /^(62[0-9]{14,17})$/i.test(value)
    );
  }
  return true;
};

export const isValidCreditCardCVC = (value, cvvLength) =>
  !(!/^-?(?:\d+|\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/i.test(value) || value.toString().length < cvvLength || value.toString().length > cvvLength);
export const getCardType = (cardNumber) => {
  let cardType = null;
  const cardNum = cardNumber && cardNumber.replaceAll(' ', '');

  const cardTypeRegEx = [
    {
      expression: /^4[0-9]{12}(?:[0-9]{3})?$/,
      type: 'visa',
    },
    {
      expression: /^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/,
      type: 'mastercard',
    },
    {
      expression: /^3[47][0-9]{13}$/,
      type: 'amex',
    },
    {
      expression: /^3(?:0[0-5]|[68][0-9])[0-9]{11}/,
      type: 'dinersclub',
    },
    {
      expression: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
      type: 'discover',
    },
    {
      expression: /^(?:2131|1800|35\d{3})\d{11}/,
      type: 'jcb',
    },
    {
      expression: /(^(2014)|^(2149))\d{11}$/,
      type: 'enroute',
    },
  ];

  cardTypeRegEx.forEach((regex) => {
    const re = new RegExp(regex.expression);
    if (re.test(cardNum.toString()) === true) {
      cardType = regex.type;
      return true;
    }
    return false;
  });

  return cardType;
};
export const isValidCreditCardMonth = (expiryMonth, expiryYear) => {
  const month = new Date().getMonth() + 1;
  const year = new Date().getFullYear();

  let isValid = true;
  if (Number(expiryMonth) > 0 && !/^-?(?:\d+|\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/i.test(expiryMonth) === false && Number(expiryMonth) <= 12) {
    if (parseInt(expiryYear) > 0) {
      // if year is entered
      if (parseInt(expiryYear) === year && parseInt(expiryMonth) < month) {
        // if year is same as current year, month should be greater than current one.
        isValid = false;
      }
    }
  } else {
    isValid = false;
  }
  return isValid;
};

export const isValidCreditCardExpiryYear = (expiryYear) => {
  let isValid = true;
  const year = new Date().getFullYear();
  if (Number(expiryYear) > 0 && !/^-?(?:\d+|\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/i.test(expiryYear) === false) {
    if (parseInt(expiryYear) < year) {
      isValid = false;
    }
  } else {
    isValid = false;
  }
  return isValid;
};

export const allowOnlyValidNumber = (e) => {
  // To restrict Special chars and chars.
  const event = e || window.event;
  const keyCode = event.keyCode || event.which;
  const formatedKeyCode = String.fromCharCode(keyCode);
  if ((keyCode >= 96 && keyCode <= 105) || (keyCode >= 48 && keyCode <= 57) || keyCode === 9 || keyCode === 37 || keyCode === 39) {
    if (
      e.key === '!' ||
      e.key === '#' ||
      e.key === '$' ||
      e.key === '%' ||
      e.key === '^' ||
      e.key === '&' ||
      e.key === '*' ||
      e.key === '(' ||
      e.key === ')' ||
      e.key === '@'
    ) {
      event.returnValue = false;
      if (event.preventDefault) event.preventDefault();
    }
    return true;
  }
  const rexEx = /^[0-9.\b]+$/;
  if (!rexEx.test(formatedKeyCode)) {
    event.returnValue = false;
    if (event.preventDefault) event.preventDefault();
  }
};
// function isValidDate(date) {
//   // Assumes date is "mm/dd/yyyy"
//   if (!/^\d\d\/\d\d\/\d\d\d\d$/.test(date)) {
//     return false;
//   }
//   const parts = date.split('/').map((p) => parseInt(p));
//   parts[0] -= 1;
//   const d = new Date(parts[2], parts[0], parts[1]);
//   return d.getMonth() === parts[0] && d.getDate() === parts[1] && d.getFullYear() === parts[2];
// }

export const isPoBoxAddress = (address) => {
  const tokens =
    address &&
    address
      .replace(/^a-zA-Z0-9\\s+/g, '')
      .toUpperCase()
      .split(' ')
      .map((item) => item.replace(',', ''));
  return tokens && ((tokens.includes('PO') && tokens.includes('BOX')) || tokens.includes('POBOX') || tokens.includes('BOXPO'));
};
